import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Offcanvas, OffcanvasBody,Badge } from "reactstrap";
import ScrollspyNav from "./scrollSpy";


//Import Images
import logodark from "../../assets/imgs/LogoClosure.png";


import RightSidebar from '../../componentes/Layout/RightSidebar';


class NavbarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Início" },
        { id: 3, idnm: "service", navheading: "Funcionalidades" },
        { id: 3, idnm: "testimonial", navheading: "Depoimentos" },
        { id: 4, idnm: "pricing", navheading: "Planos" },
        { id: 6, idnm: "contact", navheading: "Contatos" },
      ],
      open: false,
      position: 'end',
      isOffcanvasOpen: false
    };
    this.toggleLine = this.toggleLine.bind(this);
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
  }

  toggleOffcanvas = () => {
    this.setState((prevState) => ({
      isOffcanvasOpen: !prevState.isOffcanvasOpen,
    }));
  };

  closeOffcanvas = () => {
      this.setState({ isOffcanvasOpen: false });
  };

  toggleLine() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }
  toggleRightDrawer = () => {
    this.setState({ position: 'right' });
    this.setState({ open: !this.state.open });
  };
  onDrawerClose = () => {
    this.setState({ open: false });
  };

  initMenu() {
    this.activateMenu();
  }

  render() {
    //Store all Navigationbar Id into TargetID variable(Used for Scrollspy)
    let targetId = this.state.navItems.map((item) => {
      return item.idnm;
    });

    const { isOffcanvasOpen } = this.state;

    return (
      <React.Fragment>
        <header id="topnav" className="defaultscroll sticky">
          <Container>
            <div>
              <Link className="logo" to="#">
                <img src={logodark} height="50" alt="" />
              </Link>
            </div>
            <ul  className="buy-button list-inline mb-0">
              
              <li className="list-inline-item button mb-0 ps-1 ">
              <Link
                    to="/signup"
                    onClick={this.togglemodal}
                    className="btn btn-outline-primary"
                  >
                    Comece Grátis
                    <Badge className="badge rounded-pill bg-danger ms-2">
                      por 7 dias
                    </Badge>
                  </Link>
              </li>
              <li className="list-inline-item button mb-0 ps-1 ">
              <Link
                    to="/app"
                    onClick={this.togglemodal}
                    className="btn btn-primary mt-2"
                  >
                    Entrar{" "}
                  </Link>
              </li>
            </ul>
            <div className="menu-extras">
              <div  className="menu-item">
                <Link
                  to="#"
                  onClick={this.toggleLine}
                  className={
                    this.state.isOpen ? "navbar-toggle open" : "navbar-toggle"
                  }
                >
                  <div className="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </Link>
              </div>
            </div>
            <ScrollspyNav
              scrollTargetIds={targetId}
              scrollDuration="800"
              headerBackground="false"
              activeNavClass="active"
            >
              <div
                id="navigation"
                style={{ display: this.state.isOpen ? "block" : "none" }}
              >
                <ul  className="navigation-menu">
                  {this.state.navItems.map((item, key) => (
                    <li
                      key={key}
                      className={
                        item.navheading === "Home"
                          ? "has-submenu active"
                          : "has-submenu"
                      }
                    >
                      <a href={"#" + item.idnm}> {item.navheading}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </ScrollspyNav>
          </Container>
        </header>
        <Offcanvas isOpen={isOffcanvasOpen} direction={this.state.position} toggle={this.toggleOffcanvas}>
            <OffcanvasBody>
                <RightSidebar onClose={this.closeOffcanvas} />
            </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    );
  }
}

export default NavbarPage;
